import { render } from "./ModalHistorialPropiedad.vue?vue&type=template&id=f20bff92&scoped=true"
import script from "./ModalHistorialPropiedad.vue?vue&type=script&lang=js"
export * from "./ModalHistorialPropiedad.vue?vue&type=script&lang=js"

import "./ModalHistorialPropiedad.vue?vue&type=style&index=0&id=f20bff92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20bff92"]])

export default __exports__